import { render, staticRenderFns } from "./RadioBox.vue?vue&type=template&id=9f79fb7e"
import script from "./RadioBox.vue?vue&type=script&lang=js"
export * from "./RadioBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f79fb7e')) {
      api.createRecord('9f79fb7e', component.options)
    } else {
      api.reload('9f79fb7e', component.options)
    }
    module.hot.accept("./RadioBox.vue?vue&type=template&id=9f79fb7e", function () {
      api.rerender('9f79fb7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic/RadioBox.vue"
export default component.exports